import CancellableHelper from "@/requests/CancellableHelper";
import { DescriptionRole } from "@/models/api/administration/roles/DescriptionRole";
import { OfficeRole } from "@/models/api/administration/roles/OfficeRole";
import { PermissionGroup } from "@/models/api/administration/roles/PermissionGroup";
import { UserInRole } from "@/models/api/administration/roles/UserInRole";
import { NewRole } from "@/models/api/administration/roles/NewRole";

//#region Routes
export const URL_GET_DESCRIPTION_ROLE = "/role/${RoleId}/office/${OfficeId}/Description";
export const URL_GET_PERMISSIONS_FOR_ROLE = "/role/${RoleId}/office/${OfficeId}/Permission";
export const URL_GET_USERS_IN_ROLE = "/role/${RoleId}/office/${OfficeId}/User";
export const URL_GET_ROLES_FOR_OFFICE = "/role/office/${OfficeId}";
export const URL_POST_REMOVE_ROLE_IN_OFFICE = "/role/${RoleId}/office/${OfficeId}/Remove";
export const URL_POST_ADD_ROLE_FOR_OFFICE = "/role/office/${OfficeId}/Add";
export const URL_POST_ADD_PERMISSION_TO_ROLE = "/role/${RoleId}/office/${OfficeId}/Permission/${PermissionId}/Add";
export const URL_POST_REMOVE_PERMISSION_FROM_ROLE =
  "/role/${RoleId}/office/${OfficeId}/Permission/${PermissionId}/Remove";
//#endregion

const _getDescriptionRole = new CancellableHelper<DescriptionRole>(URL_GET_DESCRIPTION_ROLE, DescriptionRole);
export const getDescriptionRole = async (roleId: string, officeId: string): Promise<DescriptionRole> => {
  return await _getDescriptionRole.get({ RoleId: roleId, OfficeId: officeId });
};

const _getRolesForOffice = new CancellableHelper<Array<OfficeRole>>(URL_GET_ROLES_FOR_OFFICE, OfficeRole);
export const getRolesForOffice = async (officeId: string): Promise<Array<OfficeRole>> => {
  return await _getRolesForOffice.get({ OfficeId: officeId });
};

const _addRoleForOffice = new CancellableHelper<string | null>(URL_POST_ADD_ROLE_FOR_OFFICE, "string", true);
export const addRoleForOffice = async (officeId: string, newRole: NewRole): Promise<string> => {
  const addedRoleId = await _addRoleForOffice.post({ OfficeId: officeId }, newRole);
  if (addedRoleId === null) {
    throw new Error("Can not create role");
  }
  return addedRoleId;
};

export const removeRoleInOffice = async (roleId: string, officeId: string): Promise<void> => {
  const _removeRoleInOffice = new CancellableHelper<void>(URL_POST_REMOVE_ROLE_IN_OFFICE, null, true);
  return await _removeRoleInOffice.post({ RoleId: roleId, OfficeId: officeId }, null);
};

const _getPermissionsForRole = new CancellableHelper<Array<PermissionGroup>>(
  URL_GET_PERMISSIONS_FOR_ROLE,
  PermissionGroup
);
export const getPermissionsForRole = async (roleId: string, officeId: string): Promise<Array<PermissionGroup>> => {
  return await _getPermissionsForRole.get({ RoleId: roleId, OfficeId: officeId });
};

export const addPermissionToRole = async (roleId: string, officeId: string, permissionId: number): Promise<void> => {
  const _addPermissionToRole = new CancellableHelper<void>(URL_POST_ADD_PERMISSION_TO_ROLE, null, true);
  return await _addPermissionToRole.post({ RoleId: roleId, OfficeId: officeId, PermissionId: permissionId }, null);
};

export const removePermissionFromRole = async (
  roleId: string,
  officeId: string,
  permissionId: number
): Promise<void> => {
  const _removePermissionFromRole = new CancellableHelper<void>(URL_POST_REMOVE_PERMISSION_FROM_ROLE, null, true);
  return await _removePermissionFromRole.post({ RoleId: roleId, OfficeId: officeId, PermissionId: permissionId }, null);
};

const _getUsersInRole = new CancellableHelper<Array<UserInRole>>(URL_GET_USERS_IN_ROLE, UserInRole);
export const getUsersInRole = async (roleId: string, officeId: string): Promise<Array<UserInRole>> => {
  return await _getUsersInRole.get({ RoleId: roleId, OfficeId: officeId });
};
